import ActionTypes from '../actions/actionTypes';

const initialState = {
  transactionsLoading: false,
  transactionsLoaded: false,
  transactionsError: false,
  transactions: [],
  transactionsTotalSize: 0,

  transactionItemsLoading: false,
  transactionItemsLoaded: false,
  transactionItemsError: false,
  transactionItems: [],
  transactionItemsTotalSize: 0
};

function transactionsReducer(state = initialState, { type, payload }) {
  let transactions, transactionsTotalSize, transactionItems, transactionItemsTotalSize;
  switch (type) {
    case ActionTypes.TRANSACTIONS.REQUEST:
      return {
        ...state,
        transactionsLoading: true,
        transactionsError: false,
        transactionsLoaded: false,
      };
    case ActionTypes.TRANSACTIONS.SUCCESS:
      transactions = payload.transactions;
      transactionsTotalSize = payload.totalSize;
      return {
        ...state,
        transactionsLoading: false,
        transactions,
        transactionsTotalSize,
        transactionsLoaded: true,
      };
    case ActionTypes.TRANSACTIONS.FAILURE:
      return {
        ...state,
        transactionsLoading: false,
        transactionsError: true,
        transactions: [],
        transactionsTotalSize: 0,
      };
    case ActionTypes.TRANSACTIONS.RESET:
      return {
        ...state,
        transactionsLoading: false,
        transactions: [],
        transactionsTotalSize: 0,
        transactionsLoaded: false,
        transactionsError: false,
      };
    case ActionTypes.TRANSACTIONITEMS.REQUEST:
      return {
        ...state,
        transactionItemsLoading: true,
        transactionItemsError: false,
      };
    case ActionTypes.TRANSACTIONITEMS.SUCCESS:
      transactionItems = payload.transactionItems;
      transactionItemsTotalSize = payload.totalSize;
      return {
        ...state,
        transactionItemsLoading: false,
        transactionItems,
        transactionItemsTotalSize,
      };
    case ActionTypes.TRANSACTIONITEMS.FAILURE:
      return {
        ...state,
        transactionItemsLoading: false,
        transactionItemsError: true,
      };
    case ActionTypes.TRANSACTIONS.FILTER.REQUEST:
      return {
        ...state,
        transactionsLoading: true,
        transactionsError: false,
      };
    case ActionTypes.TRANSACTIONS.FILTER.SUCCESS:
      transactions = payload.transactions;
      transactionsTotalSize = payload.totalSize;
      return {
        ...state,
        transactionsLoading: false,
        transactionsError: false,
        transactions,
        transactionsTotalSize,
      };
    case ActionTypes.TRANSACTIONS.FILTER.FAILURE:
      return {
        ...state,
        transactionsLoading: false,
        // when filtering the transaction, server returns 500 error when account no not found, it is not an error. only transaction table need to show no content
        transactionsError: false,
      };
    default:
      return state;
  }
}

export default transactionsReducer;
